import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import MasonryWall from '@yeger/vue2-masonry-wall'

Vue.config.productionTip = false
Vue.use(MasonryWall);
new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
